import { makeStyles } from '@material-ui/core'

export const useSwitchStyles = makeStyles((theme) => ({
  formGroupContainer: {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },

  container: {
    color: theme.app.colors.text.primary,
    fontSize: theme.app.typography.body.fontSize,
    fontWeight: 400,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    '& .MuiFormControlLabel-label': {
      fontFamily: 'Poppins, sans-serif !important'
    },

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row-reverse',
      justifyContent: 'space-between',
      width: '100%',
      marginBottom: 8
    }
  },

  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1)
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.primary.main,
      '& + $track': {
        backgroundColor: theme.palette.secondary.main,
        opacity: 1,
        border: 'none'
      }
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff'
    }
  },
  thumb: {
    width: 24,
    height: 24
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[400],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border'])
  },
  checked: {},
  focusVisible: {}
}))
